import { render, staticRenderFns } from "./data101.vue?vue&type=template&id=0b261f22&scoped=true"
import script from "./data101.vue?vue&type=script&lang=js"
export * from "./data101.vue?vue&type=script&lang=js"
import style1 from "./data101.vue?vue&type=style&index=1&id=0b261f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b261f22",
  null
  
)

export default component.exports